import React from "react";
import { ArrowRight } from "lucide-react";
import { BRAND, MEDIA } from "../data/content";
import Marquee from "./Marquee";

const Hero = ({ onCTAClick }) => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      className="relative pt-4 md:pt-8 pb-14 md:pb-24 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Бегущая строка — только на десктопе */}
      <Marquee className="absolute -top-3 left-0 right-0 opacity-90 hidden lg:block" />

      {/* Печать EST 2011 — десктоп */}
      <div className="hidden lg:block absolute top-32 right-12 z-0 rotate-[8deg] opacity-90">
        <div className="relative w-36 h-36 rounded-full border-[2.5px] border-burgundy flex items-center justify-center text-burgundy">
          <div className="absolute inset-2 rounded-full border-[1px] border-burgundy/60" />
          <div className="text-center leading-tight px-2">
            <div className="font-heading text-base">EST</div>
            <div className="font-heading text-3xl text-burgundy">2011</div>
            <div className="text-[9px] uppercase tracking-[0.32em] font-bold mt-1">Брянск</div>
          </div>
        </div>
      </div>

      <div className="container-x relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8 items-end pt-6 lg:pt-36">
        {/* ЛОГОТИП — на мобилке первым (сверху), на десктопе уходит вправо */}
        <div
          className="lg:col-span-5 lg:order-2 relative z-10 flex justify-center lg:justify-end animate-fadeUp"
          style={{ animationDelay: "60ms" }}
        >
          <div className="relative w-full max-w-md">
            <div className="absolute -top-3 -left-3 right-3 bottom-3 md:-top-5 md:-left-5 md:right-5 md:bottom-5 border-2 border-burgundy -z-10" />
            <div className="absolute -bottom-3 -right-3 w-20 h-20 md:w-24 md:h-24 bg-gold/30 -z-10" />
            <div className="bg-cream-paper border-2 border-burgundy p-5 md:p-9 relative">
              <img
                src={MEDIA.hero_illustration}
                alt="Логотип мастерской «Щётка»"
                className="w-full h-auto"
                data-testid="hero-illustration"
              />
              <div className="mt-5 pt-5 border-t-2 border-burgundy/80 flex items-baseline justify-between gap-3">
                <p className="font-heading text-xl md:text-2xl text-burgundy leading-none">
                  Ручная работа
                </p>
                <span className="text-[10px] uppercase tracking-[0.24em] md:tracking-[0.28em] text-muted_ink font-bold whitespace-nowrap">
                  Брянск · с 2011
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ТЕКСТ — на мобилке снизу логотипа, на десктопе слева */}
        <div className="lg:col-span-7 lg:order-1 relative z-10 animate-fadeUp">
          {/* Большой заголовок + слоган — ТОЛЬКО на десктопе (на мобилке всё это уже есть в логотипе) */}
          <h1
            className="hidden lg:block font-heading text-burgundy heading-tight text-[11.5rem] xl:text-[13rem]"
            data-testid="hero-title"
          >
            ЩЁТКА
          </h1>

          <p className="hidden lg:block mt-6 heading-tight">
            <span className="accent text-burgundy text-6xl lg:text-7xl">
              {BRAND.slogan}.
            </span>
          </p>

          {/* Описание — видно везде */}
          <p
            className="mt-2 lg:mt-8 max-w-xl lede text-ink/90"
            data-testid="hero-description"
          >
            {BRAND.description}
          </p>

          {/* CTA — видны везде */}
          <div className="mt-8 lg:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={onCTAClick}
              className="btn-primary group"
              data-testid="hero-cta-request"
            >
              Оставить заявку
              <ArrowRight
                size={16}
                strokeWidth={2.5}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
            <button
              onClick={() => scrollTo("services")}
              className="btn-ghost"
              data-testid="hero-cta-services"
            >
              Услуги и цены
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
